export function createFormData(state) {
  const formData = new FormData();
  formData.append('station_info', state.info);
  formData.append('station_image', state.fileValue);
  return formData;
}
